import styled from "styled-components";
import { colors, devicesNovo } from "../../../utils/styled/_variables.styled";
import { gridNovoConhecer } from "../../../utils/styled/_grid.style";

export const FooterLinksContent = styled.div`
  ${gridNovoConhecer("")}

  @media ${devicesNovo.tablet} {
    padding-left: 26% !important;
  }
  
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media ${devicesNovo.mobile}, ${devicesNovo.tablet} {
      flex-wrap: wrap;
    }

    div {
      display: block;
      flex-direction: column;
      margin-top: 20px;
      margin-right: 10px;

      @media ${devicesNovo.mobile}, ${devicesNovo.tablet} {
        width: 50%;
        margin-right: 0px;
      }
    }

    a.main-link {
      font-family: Averta Std;
      font-weight: 800;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.07px;
      text-align: left;
      color: ${colors.white};
      text-decoration: none;
      padding-bottom: 3px;
      width: fit-content;

      &:hover {
        border-bottom: 3px solid ${colors.yellow};
      }

      @media ${devicesNovo.mobile}, ${devicesNovo.tablet} {
        text-align: center;
        margin-top: 30px;
        font-weight: 400;
      }
    }

    a.sub-link {
      font-family: Averta Std;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.07px;
      text-align: left;
      color: ${colors.white};
      text-decoration: none;
      padding-bottom: 3px;
      width: fit-content;

      &:hover {
        border-bottom: 3px solid ${colors.yellow};
      }
    }

    @media ${devicesNovo.mobile}, ${devicesNovo.tablet} {
      a.sub-link {
        display: none;
        visibility: hidden;
      }
    }
  }
`;
